import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BookDemoDialogComponent } from "../../form/book-demo-dialog/book-demo-dialog.component";

@Component({
  selector: "app-hero-pannel",
  templateUrl: "./hero-banner.component.html",
  styleUrls: ["./hero-banner.component.scss"],
})
export class HeroPannelComponent {
  constructor(private dialog: MatDialog) { }

  openDemoBooking() {
    this.dialog.open(BookDemoDialogComponent, {
      width: '100%',
      maxWidth: '500px',
      panelClass: 'book-demo-dialog',
      data: {}
    });
  }

  downloadCatalogue() {
    // TODO: Implement catalogue download functionality
    // This could trigger a file download or open a PDF
    console.log('Download Catalogue clicked');
  }

  logos = [
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/f9LzRdQHvbh830A27NxRPowJx04XYcEm6gqDxe5P.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/NgfrHLrKR5iZHcOVqFKiPZbkFTwNSOUT6PAcmV2T.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/0MulE23Y8dj8OwXwDnkTFw942yotXxLZcVIrkJlV.jpg', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/WCScWap97n69NCqttJvIPyTHKr3HaCuCnZsopM66.jpg', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/GiEZ6TtB0B5y1LytVpkCOKe8y2wPVlejJoFYVI88.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/4hrctrjSgQeWXKthKeKrOMe0xbTxFeooRVLC7Y0t.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/24zayvTBQulynlmRfeLbO1TWy44fuE21H79rWqye.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/Ltbz9uQAuBNyjdcszwGajG4jnGPefb4DuzX9PogI.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/sBCPOUpcNFKQhqioRZBpdn4lgkrmD025YcNmFvJJ.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/WufdhEyxSx6U0FNwK0R38tFiiZ31fDXqSi63kwuG.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/nDBhu2so5vqxcHKdeGGGMgV2hX6DnzEwv997bV8U.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/lyuDmEaG26VTBGWUrrTofVSsY3Gpne2GN7ZCJPfF.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/2Hi56rr9lz6w5kOCMLEFe0cr3mLfZBK7ROgbobQ3.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/dSQIVwWE9E1OBhoRqcDj1vlvk9zqqzbyWmwrQVEZ.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/U1n1LJmOceTY07j5R1RuJMjKzF2tozw57R8dV9NX.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/PMYebAeoLVHlfgsgJCFsfhOITjRkC8Chqxt0pMTo.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/cHZIsx8Noc2xhfkHLo5pRbD1xPK0rIy4COZYIQLx.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/szfCie1GTxdku1FvXM0tEH0PC8S1O1HjjLoBf2bI.png', alt: '' },
    { src: 'https://d3uop73ba1wtqg.cloudfront.net/uploads/NV6ktNaIxLERxeswi9Y8HvDnGlz10WXvxlE3af8y.png', alt: '' },
  ];
}
